var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDotCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none",
  viewBox: "0 0 59 59",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M5.42 37.883c2.116-.402 3.488-2.532 3.065-4.756s-2.482-3.702-4.598-3.3S.4 32.36.822 34.585c.423 2.225 2.482 3.702 4.598 3.3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M8.432 25.226c.425-2.224-.945-4.355-3.06-4.76S1.195 21.536.77 23.76c-.425 2.224.945 4.355 3.06 4.76s4.176-1.07 4.602-3.294",
  opacity: 0.941
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M11.163 18.209c1.188-1.927.666-4.406-1.168-5.537-1.833-1.13-4.283-.484-5.471 1.444-1.189 1.927-.666 4.406 1.168 5.536 1.833 1.13 4.283.484 5.471-1.443",
  opacity: 0.882
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M16.204 12.481c1.793-1.383 2.18-3.887.864-5.592-1.315-1.706-3.835-1.967-5.628-.584s-2.18 3.887-.864 5.593c1.315 1.705 3.835 1.966 5.628.583",
  opacity: 0.824
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M23.271 8.905c2.174-.633 3.449-2.823 2.847-4.89-.602-2.069-2.853-3.233-5.027-2.6s-3.449 2.823-2.847 4.891 2.853 3.232 5.027 2.599",
  opacity: 0.765
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M35.573 4.668C35.779 2.524 34.12.61 31.866.393s-4.249 1.345-4.455 3.49c-.207 2.143 1.453 4.057 3.707 4.274s4.248-1.345 4.455-3.489",
  opacity: 0.706
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M43.93 8.637c.96-1.927.097-4.309-1.93-5.32-2.026-1.01-4.447-.267-5.409 1.66s-.098 4.31 1.929 5.32c2.026 1.011 4.448.268 5.41-1.66",
  opacity: 0.647
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M50.196 15.17c1.578-1.466 1.609-4 .069-5.659-1.54-1.66-4.07-1.817-5.648-.352-1.578 1.466-1.61 3.999-.069 5.658 1.54 1.66 4.069 1.817 5.648.352",
  opacity: 0.588
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M53.856 23.685c2.002-.795 2.947-3.146 2.111-5.25s-3.136-3.167-5.138-2.372-2.947 3.146-2.111 5.25 3.136 3.167 5.138 2.372",
  opacity: 0.529
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M58.026 29.233c.004-2.264-1.738-4.104-3.892-4.108-2.154-.005-3.904 1.828-3.908 4.092s1.737 4.103 3.891 4.108 3.904-1.828 3.909-4.092",
  opacity: 0.471
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M56.098 39.693c.823-2.109-.136-4.454-2.142-5.237s-4.3.291-5.124 2.4.135 4.455 2.142 5.238 4.3-.291 5.124-2.4",
  opacity: 0.412
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M50.628 48.468c1.514-1.684 1.442-4.216-.16-5.656s-4.127-1.242-5.64.442c-1.515 1.684-1.443 4.216.159 5.656s4.127 1.242 5.641-.442",
  opacity: 0.353
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M42.445 54.83c2.017-1.029 2.858-3.419 1.879-5.337-.98-1.919-3.409-2.64-5.426-1.61-2.016 1.03-2.858 3.42-1.878 5.338s3.408 2.64 5.425 1.61",
  opacity: 0.294
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M31.889 57.948c2.254-.21 3.92-2.118 3.72-4.262-.199-2.145-2.188-3.714-4.443-3.504s-3.92 2.118-3.72 4.263c.198 2.145 2.188 3.713 4.442 3.503",
  opacity: 0.235
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M26.24 54.268c.598-2.07-.681-4.256-2.857-4.884-2.175-.628-4.423.54-5.02 2.61-.598 2.07.681 4.256 2.857 4.884 2.175.628 4.423-.54 5.02-2.61",
  opacity: 0.176
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M17.427 51.656c1.29-1.725.867-4.223-.947-5.58-1.813-1.355-4.328-1.057-5.619.668-1.29 1.724-.866 4.222.947 5.578 1.813 1.357 4.33 1.058 5.62-.666",
  opacity: 0.118
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-brand-primary, currentColor)",
  d: "M10.312 46.077c1.82-1.153 2.311-3.639 1.099-5.551s-3.67-2.528-5.49-1.375c-1.818 1.153-2.31 3.639-1.098 5.551s3.67 2.528 5.49 1.375",
  opacity: 0.059
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDotCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dot-circle.f06e8547f10f799fc40f1ae3eeff7ab0.svg";